<template>
  <InputPopover
    ref="popover"
    v-bind="{ modelValue, icon, borderless, outlined, dense, error, errorMessage, label, placeholder, useInput, clearable, autofocus, separator, multiple, disable, hideSelected, display, valueDebounce, showSelection, hideOnFirstClick, inputClass }"
    :search="search"
    :loading="loading"
    :results="results"
    :placeholder="placeholder"
    :debounce="900"
    friendly-name="invoice"
    option-label="invoice_number"
    separator
    @blur="onBlur"
    @clear="onClear"
    @update:model-value="onInput"
    @clicked-result="onClickedResult"
    @removed-result="onRemovedResult"
  >
    <template v-if="$slots.advanced" #advanced>
      <slot name="advanced" />
    </template>

    <template #option="scope">
      <invoice-item
        v-bind="scope.itemProps"
        :invoice="scope.opt"
        :with-client="false"
        dense
      >
        <template v-if="showSelection" #default>
          <component
            :is="multiple ? 'q-checkbox' : 'q-radio'"
            :model-value="scope.selected"
            :val="true"
            dense
            class="no-pointer-events"
          />
        </template>
      </invoice-item>
    </template>

    <template
      #selected-chip="scope"
    >
      <invoice-chip
        dense
        removable
        without-btns
        :invoice="scope.opt"
        @click.stop
        @remove="removeModelAtIndex(scope.index)"
      />
    </template>
  </InputPopover>
</template>

<script>
import InputPopover from 'components/partials/search/inputPopover/InputPopover'
import inputPopoverMixin from 'components/partials/search/inputPopover/inputPopoverMixin'

import searchMixin from './mixins/searchMixin'

export default {
  components: {
    InputPopover
  },
  mixins: [searchMixin, inputPopoverMixin],
  props: {
    onlyPartiallyPaid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      viewingClientID: null
    }
  },
  methods: {
    search (val, update, abort) {
      this.doSearch({
        value: val,
        partially_paid: this.onlyPartiallyPaid
      }, () => {
        update()
      }, () => {
        abort()
      })
    }
  }
}
</script>
